var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "reminder" },
    [
      _c("w-select", {
        attrs: { items: _vm.channelItems },
        model: {
          value: _vm.reminder.Channel,
          callback: function ($$v) {
            _vm.$set(_vm.reminder, "Channel", $$v)
          },
          expression: "reminder.Channel",
        },
      }),
      _c("w-input-number", {
        staticClass: "reminder-amount",
        attrs: { decimals: 0 },
        on: {
          blur: function ($event) {
            return _vm.updateMinutes()
          },
        },
        model: {
          value: _vm.amount,
          callback: function ($$v) {
            _vm.amount = $$v
          },
          expression: "amount",
        },
      }),
      _c("w-select", {
        attrs: { items: _vm.unitItems },
        on: {
          input: function ($event) {
            return _vm.updateMinutes()
          },
        },
        model: {
          value: _vm.unit,
          callback: function ($$v) {
            _vm.unit = $$v
          },
          expression: "unit",
        },
      }),
      _c("w-button", {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip",
            value: _vm.$ct("delete-reminder"),
            expression: "$ct('delete-reminder')",
          },
        ],
        staticClass: "danger",
        attrs: { flat: "", round: "", icon: "trash" },
        on: {
          click: function ($event) {
            return _vm.$emit("remove")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }